import React from 'react';
import { useParams } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import { Navbar } from './common/Catalyst/navbar';
import { SidebarLayout } from './common/Catalyst/sidebar-layout';
import VendorList from './VendorList';

interface VendorPageProps {
  currentPage: string;
}

const VendorPage: React.FC<VendorPageProps> = ({ currentPage }) => {
  const { hoaId } = useParams<{ hoaId?: string }>();

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
      // The list uses the whole panel and scrolls inside itself, with its
      // filter bar as the top row, like violations and work orders.
      fill
      flush
    >
      {/* No page heading: the sidebar already says where you are. */}
      <VendorList hoaId={hoaId} fill />
    </SidebarLayout>
  );
};

export default VendorPage;
